export const LOAN_OFFERS_FETCH_SUCCESS = 'LOAN_OFFERS_FETCH_SUCCESS';

// UI
export const LOAN_OFFER_LOADING_START = 'LOAN_OFFER_LOADING_START';
export const LOAN_OFFER_LOADING_STOP = 'LOAN_OFFER_LOADING_STOP';

// deprecated
export const RECEIVE_LOAN_OFFER = "RECEIVE_LOAN_OFFER";


// loan plan
export const RECEIVE_LOAN_PLAN = "RECEIVE_LOAN_PLAN";
export const RECEIVE_LOAN_PLANS = "RECEIVE_LOAN_PLANS";
export const RECEIVE_LOAN_PLANS_SUMMARY = "RECEIVE_LOAN_PLANS_SUMMARY";
export const RECEIVE_REPAYMENTS = "RECEIVE_REPAYMENTS";
export const RECEIVE_UPCOMING_PAYMENTS = "RECEIVE_UPCOMING_PAYMENTS";

export const LOAN_PLAN_LOADING_STOP = "LOAN_PLAN_LOADING_STOP";
export const LOAN_PLAN_LOADING_START = "LOAN_PLAN_LOADING_START";


// LMS payment schedules
export const PAYMENT_SCHEDULE_FETCH_SUCCESS = "PAYMENT_SCHEDULE_FETCH_SUCCESS";
export const PAYMENT_SCHEDULE_CREATE_SUCCESS = "PAYMENT_SCHEDULE_CREATE_SUCCESS";
export const PAYMENT_SCHEDULE_CALCULATE_SUCCESS = 'PAYMENT_SCHEDULE_CALCULATE_SUCCESS';
export const PAYMENT_SCHEDULE_SELECTED = "PAYMENT_SCHEDULE_SELECTED";

// for resubmission ph cheque verifications
export const FOR_RESUBMISSION_CHEQUE_VERIFICATION_LOADING_START = "FOR_RESUBMISSION_CHEQUE_VERIFICATION_LOADING_START"
export const FOR_RESUBMISSION_CHEQUE_VERIFICATION_LOADING_STOP = "FOR_RESUBMISSION_CHEQUE_VERIFICATION_LOADING_STOP"
export const FOR_RESUBMISSION_CHEQUE_VERIFICATIONS_FETCH_SUCCESS = "FOR_RESUBMISSION_PH_CHEQUE_VERIFICATIONS_FETCH_SUCCESS"



// WEBPACK FOOTER //
// ./src/features/loans/actionTypes.js